import request from '@/utils/request'
import type { User, RoleVO } from '@/types/entities'

export interface CreateUserParams {
  username: string
  realName: string
  email?: string
  phone?: string
  roleIds: number[]
  role?: string
  department?: string
  password?: string
  orgId?: number | null
}

export interface UpdateUserParams {
  realName?: string
  email?: string
  phone?: string
  roleIds?: number[]
  role?: string
  department?: string
  status?: 'ACTIVE' | 'INACTIVE'
  orgId?: number | null
}

export const getUsers = (params?: { orgId?: number }): Promise<User[]> => {
  return request.get('/api/users', { params })
}

export const createUser = (params: CreateUserParams): Promise<User> => {
  return request.post('/api/users', params)
}

export const updateUser = (id: number, params: UpdateUserParams): Promise<User> => {
  return request.put(`/api/users/${id}`, params)
}

export const deleteUser = (id: number): Promise<void> => {
  return request.delete(`/api/users/${id}`)
}

export const resetPassword = (id: number): Promise<{ message: string }> => {
  return request.post(`/api/users/${id}/reset-password`)
}

export const getSalesUsers = (): Promise<User[]> => {
  return request.get('/api/users/sales')
}

export const getRoles = (): Promise<RoleVO[]> => {
  return request.get('/api/roles')
}

export const getUserRoles = (userId: number): Promise<RoleVO[]> => {
  return request.get(`/api/users/${userId}/roles`)
}

export const assignUserRoles = (userId: number, roleIds: number[]): Promise<void> => {
  return request.post(`/api/users/${userId}/roles`, { roleIds })
}

export const updateUserPreference = (params: { preferredLanguage: string }): Promise<void> => {
  return request.put('/api/users/me/preference', params)
}
